import { render, staticRenderFns } from "./GameController.vue?vue&type=template&id=53b403d2&scoped=true&"
import script from "./GameController.vue?vue&type=script&lang=js&"
export * from "./GameController.vue?vue&type=script&lang=js&"
import style0 from "./GameController.vue?vue&type=style&index=0&id=53b403d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b403d2",
  null
  
)

export default component.exports